module.exports = [{
      plugin: require('D:/users/jschlechte/workspaces/github.com/jschlechte/mission-control-manual/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"stylesProvider":{"injectFirst":true}},
    },{
      plugin: require('D:/users/jschlechte/workspaces/github.com/jschlechte/mission-control-manual/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
